import { AxiosResponse } from 'axios';
import { postData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface TranslationParams {
  onlyLanguage?: string;
}

export interface TranslationInterface {
  errors?: [{ sheetTitle: string; errorMessage: string }] | any;
  success?: boolean;
}

export interface TranslationResponse {
  results: {
    [key: string]: TranslationInterface;
  };
}

export const postTranslationSync = async (params: TranslationParams): Promise<AxiosResponse<TranslationResponse>> => {
  const url = API_URLS.TRANSLATION_SYNC(params?.onlyLanguage);
  return postData<any, TranslationResponse>(url, null);
};
